import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { PERMISSION_MAP } from '../constants/routes';

const ProtectedRoute = ({
  children,
  permission
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useSelector((state) => state.auth || {});
  const { permissions: currentUserPermissions = [] } = currentUser || {};

  // Check permissions before rendering children
  useEffect(() => {
    // Skip check if not an employee or no permission required
    if (!currentUser?.is_employee_of || !permission) return;

    const userPermissionNames = currentUserPermissions.map(
      (id) => PERMISSION_MAP[id]
    );

    const hasAccess = userPermissionNames.includes(permission);

    if (!hasAccess) {
      console.log('Access denied, redirecting...');
      navigate('/access-denied', { replace: true, state: { from: location } });
    }
  }, [currentUser, permission, currentUserPermissions, navigate, location]);

  // If we're still loading user data, show a loading state
  if (!currentUser) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // If no permission is required or user has access, render children
  if (!permission || !currentUser.is_employee_of) {
    return children;
  }

  // If we get here, we're still checking permissions
  const userPermissionNames = currentUserPermissions.map(id => PERMISSION_MAP[id]);
  const hasAccess = userPermissionNames.includes(permission);
  
  if (!hasAccess) {
    return null; // Or a loading state, will be redirected by the useEffect
  }

  return children;
};

export default ProtectedRoute;